import React, {useEffect, useState} from "react";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import CheckBox from "../../../components/ComponentesFormularios/CheckBox";
import {convertToString, getItemsState, validArray} from "../../../util/functions";
import {isEmpty} from "../../../util/is";
import {useFormContext} from "react-hook-form";
import Emitter from "../../../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../../../data/ConstantEventEmitter";
import {modalSideService} from "../../../services/modalSideService";
import Tooltip from "@mui/material/Tooltip";
import {Colors} from "../../../assets/colors/Colors";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import {FixedSizeList as List} from "react-window";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import {optionsYesNo} from "../../../data/ConstantForm";
import {productosService} from "../../../services/apiProductos";
import {modalCRUDService} from "../../../services/modalCRUDService";
import {ConstantsFormCrud} from "../../../data/RoutesFormCrud";
import {GlobalConstants} from "../../../data/GlobalConstants";
import {useDispatch} from "react-redux";

export const optionsVisualizar = [
  {text: "Todos", value: 'TP'},
  {text: "Seleccionados", value: 'PS'}
]

const ViewListaProductosBySubPortafolio = ({properties}) => {

  const dispatch = useDispatch();
  const { register, handleSubmit, formState: { errors }, control, setValue, getValues } = useFormContext();
  const { subPortafolioId, params, tableRef } = properties;
  const [stateFilter, setStateFilter] = useState("");
  const [datos, setDatos] = useState({
    data: [],
    filter: []
  });
  const { data, filter } = datos;


  const handleChangeInput = (value) => {

    setStateFilter(value);

    let arrDataFiltrada = data.filter(x =>
      (convertToString(x.nbProducto)?.toUpperCase()?.includes(convertToString(value)?.toUpperCase()) ||
        convertToString(x.nmProducto)?.toUpperCase()?.includes(convertToString(value)?.toUpperCase())))

    setDatos({...datos, filter: arrDataFiltrada.slice()});

  }

  /*const handleSave = () => {

    let arrProductosBySubPortafolio = validArray(jsProductosBySubPortafolios).slice();

    let countUnChecked = 0;
    for(let item of arrProductosBySubPortafolio){

      let checkBox = stateCheckbox.find(x => convertToString(x) === convertToString(item.nbProducto));

      item.checked = !!checkBox;

      if(!item.checked){
        countUnChecked++;
      }

    }

    const countProductos = arrProductosBySubPortafolio.length;
    const rowNode = tableRef.current.api.getRowNode(params.node.id);

    rowNode.setDataValue("jsProductos", arrProductosBySubPortafolio);
    rowNode.setDataValue("totalMateriales",
      countProductos === 0
        ? '0/0'
        : `${Number(countProductos) - countUnChecked}/${countProductos}`);


    modalSideService.clear();


  }*/

  const actualizarProductoEnSubportafolio = (idProducto, nmProducto , objSubPortafolios) => {

    let arrUpdate = [];
    let arrCurrentDataUpdate = [];

    tableRef.current.api.forEachNode( (node) => {

      let data = node.data;
      data.selected = node.isSelected();

      let jsProductos = [];
      jsProductos = validArray(node?.data?.jsProductos).slice();
      let findJsProductos = jsProductos.find(x => convertToString(x.nbProducto) === convertToString(idProducto));

      if(!findJsProductos && objSubPortafolios[convertToString(node.data.id)]){
        jsProductos.push({
          nbProducto: idProducto,
          nmProducto: nmProducto
        })
        let longitudJsProductos = validArray(jsProductos).length;
        data.jsProductos = validArray(jsProductos).slice();
        data.totalMateriales = `${longitudJsProductos}/${longitudJsProductos}`;
      }
      else if(findJsProductos && !objSubPortafolios[convertToString(node.data.id)]){

        let jsProductosDeleteItem = jsProductos.filter(x => convertToString(x.id) !== convertToString(idProducto));
        let longitudJsProductos = validArray(jsProductosDeleteItem).length;
        data.jsProductos = validArray(jsProductosDeleteItem).slice();
        data.totalMateriales = `${longitudJsProductos}/${longitudJsProductos}`;

        if(convertToString(node.data.id) === convertToString(subPortafolioId)){
          arrCurrentDataUpdate = jsProductosDeleteItem.slice();
        }

      }

      arrUpdate.push(data);


    })

    tableRef.current.api.applyTransaction({ update: arrUpdate });

    setDatos({
      data: arrCurrentDataUpdate,
      filter: arrCurrentDataUpdate.filter(x =>
        (convertToString(x.nbProducto)?.toUpperCase()?.includes(convertToString(stateFilter)?.toUpperCase()) ||
          convertToString(x.nmProducto)?.toUpperCase()?.includes(convertToString(stateFilter)?.toUpperCase())))
    })

  }

  const handleEditProducto = (idProducto, nmProducto) => {

    productosService.getProductoById( idProducto ).then(
      response => {
        const {status, msg, data} = response;

        if (status) {
          modalCRUDService.showModal({
            props: {codProducto: idProducto, data: data, executeFn: (subPortafolios) => actualizarProductoEnSubportafolio(idProducto, nmProducto, subPortafolios)},
            type: ConstantsFormCrud.modalCRUDProductos,
            title: `Editar Producto #${idProducto}`,
            isAddMode: false,
            isEditable: true,
            dense: true,
            id: modalCRUDService.defaultId,
            size: `xl`});
        } else {
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
        }

      },
      error => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
      }
    );

  }

  useEffect(() => {

    let jsProductosBySubPortafolios = [];
    try{
      jsProductosBySubPortafolios = validArray(params.node.data.jsProductos);
    }
    catch (e) {jsProductosBySubPortafolios = [];}

    setDatos({data: jsProductosBySubPortafolios.slice(), filter: jsProductosBySubPortafolios.slice()});

  }, [])

  return(
    <div className="p-2">

      <div className="mb-3 d-flex align-items-center justify-content-end">
        {/*<Tooltip title="Guardar" aria-label="guardar">
          <a onClick={() => handleSave()} className="icon-container-actions d-flex">
            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
          </a>
        </Tooltip>*/}

        <Tooltip title="Cerrar" aria-label="cerrar">
          <a onClick={() => modalSideService.clear()} className="icon-container-actions d-flex mr-0">
            <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
            <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"/>
          </a>
        </Tooltip>
      </div>

      <p className="mb-0 text-justify">Aqui podrás visualizar y buscar los productos asociados al subportafolio seleccionado</p>

      <InputForm identificador={`filterProductos`} label={``} value={stateFilter}
                 placeholder="Buscar..." type="text" className={`px-0 col-12`} handleChange={({name, value}) => handleChangeInput(value)}
      />

      <hr className="mt-2 mb-3"/>

      <p className="font-weight-bold">Lista de productos</p>

      <div className="px-0 col-12">


        <List height={800} width={`100%`} itemSize={46} itemCount={filter?.length} className={`border`}>

          {
            ({index,style}) =>
              <div key={`key${index}`} style={style} className="d-flex align-items-center p-2 w-100">
                <div className="my-1 d-flex align-items-center justify-content-between w-100" key={`key${filter[index].nbProducto}`} >
                  <CheckBox
                    disabled={true}
                    identificador={`check${filter[index].nbProducto}`}
                    value={true}
                    label={`${filter[index].nbProducto} - ${filter[index].nmProducto}`}
                    styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}}
                    onChange={({name, checked}) => {}}/>
                  <i onClick={() => handleEditProducto(filter[index].nbProducto, filter[index].nmProducto)} style={{color: Colors.GREEN_SWITCH_ACTIVE, cursor: "pointer"}} className="far fa-edit fa-lg mx-1"/>
                </div>
              </div>

          }

        </List>

      </div>

    </div>
  )

}

export default ViewListaProductosBySubPortafolio;


